import { createSlice } from "@reduxjs/toolkit";

const initialRecapitulationReportState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  consolidationReportForEdit: undefined,
  lastError: null,
  // ! PROGRAM, DONOR, DONATION COUNT
  donorCount: 0,
  donationCount: 0,
  programCount: 0,
  // ? LIBRARY FILES
  consolidationReportFiles: []
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const superAdminRecapitulationReportSlice = createSlice({
  name: "recapitulationReport",
  initialState: initialRecapitulationReportState,
  reducers: {
    catchError: (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
      // state.error = `${action.type}: ${action.payload.error}`;
      // if (action.payload.callType === callTypes.list) {
      //   state.listLoading = false;
      // } else {
      //   state.actionsLoading = false;
      // }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // getconsolidationReportById
    recapitulationReportFetched: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.consolidationReportForEdit =
        action.payload.consolidationReportForEdit;
      state.donorCount = action.payload.donorCount;
      state.donationCount = action.payload.donationCount;
      state.programCount = action.payload.programCount;
    },
    // findconsolidationReport
    recapitulationReportsFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
      state.entities = items;
      state.totalCount = total_items;
    },
    // Set to default state actionLoading & error
    recapitulationReportReload: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
    },
    recapitulationReportFiles: (state, action) => {
      state.consolidationReportFiles = action.payload.items;
      state.totalCount = action.payload.total_items;
      state.listLoading = false;
      state.actionsLoading = false;
    },
    recapitulationReportFilesFetched: (state, action) => {
      state.consolidationReportFiles = action.payload.items;
      state.listLoading = false;
      state.actionsLoading = false;
    }
  }
});
